module.exports = __webpack_public_path__ + "static/media/hebebühne_fertig.0027f8c2.jpg";